module.exports = {"360727100":"龙南镇","360727101":"武当镇","360727102":"杨村镇","360727103":"汶龙镇","360727104":"程龙镇","360727105":"关西镇","360727106":"里仁镇","360727107":"渡江镇","360727108":"九连山镇","360727200":"桃江乡","360727201":"东江乡","360727202":"临塘乡","360727203":"南亨乡","360727204":"夹湖乡","360727400":"江西龙南经济技术开发区","360727500":"安基山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360727.json
// module id = 1194
// module chunks = 0